/**
 * VodkaType
 */
export type VodkaType = 'CLEAN' | 'FLAVORED';

export const VodkaType = {
  Clean: 'CLEAN' as VodkaType,
  Flavored: 'FLAVORED' as VodkaType,
};
